export default {
  switchToOld: {
    title: 'Click here for the old version',
    description: 'Click if there are problems with the current page.',
  },
  doneLabel: 'Done',
  nextLabel: 'Next',
  prevLabel: 'Previous',
}
